import * as React from 'react'
import { Modal, Form } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import PayerForm from './PayerForm'
import { flow, pipe } from 'fp-ts/lib/function'
import { editPayerAction, cancelEditAction } from './types'
import { option } from 'fp-ts'
import { checkExists } from './AddPayerModal'
import { getPayerByEmailOrPhonenumber } from './api'
import { CancelToken } from 'axios'
import { loadable } from '@library/react-toolkit'
import { Customer } from '../../types'

const checkPhoneExists = (organization: string) =>
  checkExists((phoneNumber: string, token: CancelToken) =>
    getPayerByEmailOrPhonenumber(organization, undefined, phoneNumber, token)
  )

const checkEmailExists = (organization: string) =>
  checkExists((email: string, token: CancelToken) =>
    getPayerByEmailOrPhonenumber(organization, email, undefined, token)
  )

const EditPayerModal = () => {
  const visible = useSelector(s => option.isSome(s.payers.editingPayer))
  const payer = useSelector(s =>
    pipe(
      s.payers.editingPayer,
      option.getOrElse<Customer>(() => ({
        id: 0,
        name: '',
        email: '',
        address: '',
        taxNumber: '',
        phoneNumber: '',
        nymId: undefined,
      }))
    )
  )
  const loading = useSelector(s => loadable.isLoading(s.payers.editResult))
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  React.useEffect(() => {
    if (visible) {
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      zIndex={2}
      visible={visible}
      cancelText={<FormattedMessage id="cancel" />}
      okText={<FormattedMessage id="confirm" />}
      onCancel={flow(cancelEditAction, dispatch)}
      onOk={form.submit}
      okButtonProps={{ loading }}
      title={<FormattedMessage id="editCustomer" />}
      destroyOnClose={true}
    >
      <PayerForm
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        form={form}
        onFinish={p => dispatch(editPayerAction(p))}
        initialValue={payer}
        extraRules={{
          email: [
            {
              message: <FormattedMessage id="emailExists" />,
              validator: checkEmailExists(payer.email),
            },
          ],
          phoneNumber: [
            {
              message: <FormattedMessage id="phonenumberExists" />,
              validator: checkPhoneExists(payer.phoneNumber),
            },
          ],
        }}
      />
    </Modal>
  )
}

export default EditPayerModal
